import type { AppDispatch } from "~/store";

import { apiEndpoints } from "~/services/endpoints/apiEndpoints";

export const GRID_MUTATION_REFRESH_DELAY_MS = 2000;

export const PROJECTION_REFETCH_BACKOFF_MS = [1, 2, 4].map((factor) => factor * GRID_MUTATION_REFRESH_DELAY_MS);

const refetchTagsAfterProjection = (dispatch: AppDispatch, tags: NonNullable<AddTagTypes>): (() => void) => {
	let elapsedMs = 0;
	const timeoutIds = PROJECTION_REFETCH_BACKOFF_MS.map((backoffMs) => {
		elapsedMs += backoffMs;
		return setTimeout(() => dispatch(apiEndpoints.util.invalidateTags(tags)), elapsedMs);
	});
	return () => {
		for (const timeoutId of timeoutIds) clearTimeout(timeoutId);
	};
};

export default refetchTagsAfterProjection;
